import type { SVGProps } from 'react';
const DawnFlagGY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-GY_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-GY_svg__a)">
      <path fill="#08C55F" d="M0 0h22v16H0z" />
      <path
        fill="#FFD831"
        stroke="#fff"
        strokeWidth={1.333}
        d="M-.381 15.333V.667h.27l21.444 7.277v.112L-.11 15.333z"
      />
      <path
        fill="#E92034"
        stroke="#262626"
        strokeWidth={1.333}
        d="M-.381 15.333V.667h.18L10.842 8-.2 15.333z"
      />
    </g>
  </svg>
);
export default DawnFlagGY;
